import axios from '@/axios.js';

export const advisorApi = {
  getAdvisors(payload) {
    return axios.get('admin/advisors', {
      params: payload,
    });
  },
  getAdvisor(id) {
    return axios.get(`admin/advisors/${id}?join=translations`);
  },
  addAdvisor(body) {
    return axios.post('admin/advisors', body);
  },
  updateAdvisor(id, body) {
    return axios.patch(`admin/advisors/${id}`, body);
  },
  deleteAdvisor(id) {
    return axios.delete(`admin/advisors/${id}`);
  },
  getAdvisorAppointmentConfig(id) {
    return axios.get(`admin/appointment-configs/advisors/${id}`);
  },
  updateAdvisorAppointmentConfig(id, body) {
    return axios.put(`admin/appointment-configs/advisors/${id}`, body);
  },
};
